// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1xSS8","label":"Category_label__10yxo","content":"Category_content__1lbT_","header":"Category_header__3dVYa","location":"Category_location__1O9qh"};